import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class DynamicCardFeed {
  constructor(section) {
    this.el = section.el;
    this.section = section;

    initCarousel(
      this.el,
      {
        type: 'loop',
        perPage: 1,
        gap: '1rem',
        pagination: true,
        padding: {
          right: 50,
        },
        mediaQuery: 'min',
        breakpoints: {
          [unitlessBreakpoints.xs]: {
            autoWidth: true,
            gap: '1.5rem',
          },
          [unitlessBreakpoints.md]: {
            pagination: false,
          },
        },
      },
      true,
    );
  }
}
